

function SpiroView() {
    //TODO implement
    return (
        <div/>
    );
}

export default SpiroView;